import React, { useEffect, useState } from "react";
import "../App.css";
import ScrollAnimation from "react-animate-on-scroll";
import { scroller } from "react-scroll";
import axios from "../axios";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../Images/LearnEarnLogo.png";
import heroImage from "../Images/man-with-easel-before-screen-with-video-learning-how-draw-portrait-illustration.png";
import BannerDesign from "../Images/bannerDesignImage.png";
import heroImage3 from "../Images/headerimage1.png";
import AboutImamge from "../Images/Frame 12.png";
import bgImage from "../Images/Section (2).png";
import Correct from "../Images/Vector.png";
import Info from "../Images/ph_info-duotone.png";
import ReferShare from "../Images/referlink.png";
import Askfreind from "../Images/ask friend.png";
import EarnPoints from "../Images/eran points.png";
import Star from "../Images/Container.png";
import FactImage from "../Images/fact_img.png.png";
import QuamaImage from "../Images/quamaImage.png";
import Ratingstars from "../Images/ratingstar.png";
import Upcoming from "../Images/Categorey-Icon-7.svg.png";

import Button from "../componant/Button/Button";

import { FaArrowRightLong } from "react-icons/fa6";

import CountUp from "react-countup";
import Slider from "react-slick";
import Contactus from "./Hompage/Contactus";
import HomeNavbar from "./Hompage/HomeNavbar";
import Footer from "./Hompage/Footer";
import UpcomingExam from "./Hompage/UpcomingExam";
import Contestpage from "./Hompage/Contestpage";
import FaqsPage from "./Hompage/Faqs";
import HowItsWorks from "./Hompage/HowItsWorks";
import WhyChooseUs from "./Hompage/WhyChooseUs"; 


function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "red" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "green" }}
      onClick={onClick}
    />
  );
}
function Dashboard() {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    // dots: true,
    accessibility: false,
    adaptiveHeight: true,
    // dots: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 4000,
    // nextArrow: <SampleNextArrow/>,
    // prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
          infinite: true,
          // dots: true,
          autoplay: true,
          speed: 2000,
          autoplaySpeed: 5000,
          // dots: true
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          // dots: true,
          autoplay: true,
          speed: 2000,
          autoplaySpeed: 5000,
          // initialSlide: 2
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          // dots: true,
          autoplay: true,
          speed: 2000,
          autoplaySpeed: 5000,
          // cssEase: "linear"
        },
      },
    ],
  };
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  useEffect(() => {
    async function fetchData() {
      axios.get("getAllCourses").then((response) => {
        if (response?.data) {
          setData(response?.data?.result);
          localStorage.setItem("plans", JSON.stringify(response?.data?.result));
        }
      });
    }
    fetchData();
  }, []);

  console.log(data);

  const [slideIn, setSlideIn] = useState(false);

  useEffect(() => {
    setSlideIn(true);
  }, []);

  
  // const [currentIndex, setCurrentIndex] = useState(0);
  // const cardsPerView = 4;
  // const totalCards = data.length;

  // const handlePrev = () => {
  //   setCurrentIndex((prevIndex) => (prevIndex - 1 + totalCards) % totalCards);
  // };

  // const handleNext = () => {
  //   setCurrentIndex((prevIndex) => (prevIndex + 1) % totalCards);
  // };

  //  const planss= JSON.parse(localStorage.getItem("plans"))
  //  console.log(planss)

  return (
    <div>
      {/* <Navbar /> */}
      <HomeNavbar />

      <div className=" flex flex-col items-center justify-center mt-20">
        {/* Hero Section */}
        <div
          id="home"
          className="w-full py-10 flex flex-col lg:flex-row items-center m-auto font-poppins text-center gap-10 px-6"
          style={{
            backgroundImage: `url('${bgImage}')`,
            backgroundSize: "cover",
          }}
        >
          <div className="hidden md:block hover:animate-bounce">
            <img
              src={BannerDesign}
              alt="Banner Design"
              className="transition-transform duration-500 ease-in-out transform hover:scale-105 hover:rotate-6"
            />
          </div>
          <div className="w-full lg:w-1/2">
            <h1 className="text-3xl lg:text-4xl font-extrabold font-oswald text-purple mb-2 animate-slide-in-left">
              Knowledge is Power
            </h1>
            <h1 className="text-xl lg:text-3xl font-bold font-poppins text-bgBlue mb-4 animate-slide-in-left">
              Empowering Yourself for Examination Triumph with{" "}
              <span className="text-purple font-poppins font-extrabold text-3xl lg:text-4xl">
                Learn2Earn24x7
              </span>
            </h1>
            <p className="text-sm lg:text-lg text-bgBlue mb-6 animate-slide-in-left">
              Education is a powerful tool that enables individuals to achieve
              success in various aspects of life. It opens up opportunities,
              enhances personal and professional growth, and contributes to the
              betterment of society.
            </p>
            <div className="hidden lg:flex justify-center items-center space-x-4 mt-6">
              <Button
                Text="Get Started"
                bgColor="purple"
                textColor="white"
                Links="/login"
              />
              
              <Button Text="Learn More" bgColor="white" textColor="black" Links="/about-us"/>
            </div>
          </div>
          <div
            className={`lg:w-1/2 ${slideIn ? "animate-slide-in-right" : ""}`}
          >
            <img
              src={heroImage3}
              alt="Hero"
              className="lg:max-w-2xl h-96 mb-6 lg:m-auto transition-transform duration-500 ease-in-out transform hover:scale-105 hover:rotate-6"
            />
            <div className="flex lg:hidden flex  gap-4 justify-center items-center  mt-6">
              <Button
                Text="Get Started"
                bgColor="purple"
                textColor="white"
                Links="/login"
              />
              <Button Text="Learn More" bgColor="white" textColor="black" Links="/about-us"/>
            </div>
          </div>
        </div>


        <HowItsWorks />
{/* <Howworks /> */}

        


        {/* refer & ern */}
        <ScrollAnimation
          duration={3}
          animateIn="fadeIn"
          initiallyVisible={true}
          animateOnce={true}
          className="w-full"
        >
          <div
            id="refer-earn"
            className="bg-white w-full py-12  text-center font-oswald"
          >
            <div className=" flex items-center justify-center">
              <p
                style={{ backgroundColor: "#EFEEFE" }}
                className="border-2 border rounded-full py-2 px-6 font-bold text-bgBlue"
              >
                Refer & Earn
              </p>
            </div>
            <br />
            <h2 className="text-3xl font-bold text-gray-900 mb-2 animate-fade-in">
              Refer Your Friends And{" "}
              <span className="text-purple">Earn Learn Points </span>{" "}
            </h2>
            <p className=" text-sm text-gray-900 mb-4 animate-fade-in lg:w-1/2 lg:m-auto ">
              Share the power of learning with your friends and earn rewards!
              Start sharing your referral link now and earn points to unlock
              exciting rewards!"
            </p>
            <br />
            <ScrollAnimation
              duration={3}
              animateIn="bounceInRight"
              animateOut="bounceOutLeft"
              initiallyVisible={true}
              animateOnce={true}
            >
              <div class="space-y-8 lg:w-4/5 w-full lg:grid lg:grid-cols-3 m-auto sm:gap-10 xl:gap-10 lg:space-y-0 p-4 lg:p-0 ">
                <div
                  style={{ backgroundColor: "#F1D9CC" }}
                  class="   max-w-md shadow-[6px_6px_#A695AE] xl:p-2 p-4 rounded-3xl h-56  "
                >
                  <div className="flex justify-end">
                    <img src={Star} alt="" />
                  </div>
                  <div className="flex   justify-center items-center gap-4">
                    <div className="  flex justify-between   ">
                      <img src={ReferShare} alt="" className="w-12 h-12 " />
                    </div>

                    <div class="flex flex-col gap-4 m-auto lg:m-0 text-start  ">
                      <span class=" text-xl font-bold font-oswald text-bgBlue ">
                        Share Your Refer Link
                      </span>
                    </div>
                  </div>

                  <span class=" text-sm  text-start flex mt-6 xl:px-8 font-oswald ">
                    Redeem your points for exciting rewards, including discounts
                    on courses, exclusive access to expert sessions, free trial
                    classes, and more!
                  </span>
                </div>
                <div
                  style={{ backgroundColor: "#EDEAFF" }}
                  class="   max-w-md shadow-[6px_6px_#A695AE] xl:p-2 p-6 rounded-3xl h-56  "
                >
                  <div className="flex justify-end">
                    <img src={Star} alt="" />
                  </div>
                  <div className="flex  justify-center items-center gap-4">
                    <div className="  flex justify-between   ">
                      <img src={Askfreind} alt="" className="w-12 h-12 " />
                    </div>

                    <div class="flex flex-col gap-4 m-auto lg:m-0 text-start  ">
                      <span class=" text-xl font-bold font-oswald text-bgBlue ">
                        Ask to Friend Buy Course
                      </span>
                    </div>
                  </div>

                  <span class=" text-sm  text-start flex mt-6 xl:px-8 font-oswald ">
                    By inviting your friends to join our courses, you'll not
                    only help them grow but also earn points for yourself. Start
                    asking your friends to buy courses today
                  </span>
                </div>
                <div
                  style={{ backgroundColor: "#F1FDFF" }}
                  class="   max-w-md shadow-[6px_6px_#A695AE] xl:p-2 p-6 rounded-3xl h-56  "
                >
                  <div className="flex justify-end">
                    <img src={Star} alt="" />
                  </div>
                  <div className="flex  justify-center items-center gap-4">
                    <div className="  flex justify-between   ">
                      <img src={EarnPoints} alt="" className="w-12 h-12 " />
                    </div>

                    <div class="flex flex-col gap-4 m-auto lg:m-0 text-start  ">
                      <span class=" text-xl font-bold font-oswald text-bgBlue">
                        Earn Reward Points
                      </span>
                    </div>
                  </div>

                  <span class=" text-sm  text-start flex mt-6 xl:px-8 font-oswald ">
                    Our referral program is designed to thank you for spreading
                    the word about our courses. With every referral, you'll not
                    only earn points but also help your friends unlock
                    their potential.
                  </span>
                </div>
              </div>
            </ScrollAnimation>
          </div>
        </ScrollAnimation>

        {/* Plans Section */}
        {/* <ScrollAnimation
          duration={3}
          animateIn="fadeIn"
          initiallyVisible={true}
          animateOnce={true}
          className="w-full"
        > */}
        <div
          id="plans"
          style={{
            backgroundImage: `url('${bgImage}')`,
            backgroundSize: "cover",
            //  backgroundRepeat: 'no-repeat',
            //  backgroundPosition: 'center'
          }}
          className="bg-bgWhite w-full py-6 text-center   lg:px-8 font-poppins"
        >
          <div className=" flex items-center justify-center mb-2">
            <p
              style={{ backgroundColor: "#EFEEFE" }}
              className="border-2 border rounded-full py-2 px-6 font-bold text-bgBlue"
            >
              Top Class Courses
            </p>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2 animate-fade-in">
            Explore Our World's{" "}
            <span className="text-purple">Best Courses </span>
          </h2>
          <p className=" text-sm text-gray-900 mb-4 animate-fade-in lg:w-1/2 lg:m-auto ">
            Unlock your dream government job with our expert-led courses!
            Explore our comprehensive and interactive learning programs,
            designed to help you crack the toughest government exams with ease.
            From UPSC Civil Services to SSC CGL, Banking, and Defence exams, our
            courses cover it all.
          </p>
          <ScrollAnimation
            duration={3}
            animateIn="flipInY"
            animateOnce={true}
            initiallyVisible={true}
            className="w-full"
          >
            <div class="mt-4">
              <Slider {...settings} className="slider-container">
                {data &&
                  data?.map((e, index) => {
                    if (e?.isActive) {
                      return (
                        <>
                          <div class=" flex flex-col bg-white p-6 mx-auto max-w-md text-center xl:p-8 rounded-xl w-80 relative  transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 transition duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105">
                            {/* "Best of" Tag */}

                            <div className="h-36 bg-bgBlue rounded-xl">
                              <div className="p-2 mt-2">
                                <div className="flex gap-4 py-4 justify-center items-center">
                                  <div class="absolute top-6 left-1/2 transform -translate-x-1/2 bg-purple text-white text-xs font-bold py-1 px-5 rounded ">
                                    TOP SELLING
                                  </div>
                                  <img
                                    src={e.planImage}
                                    alt=""
                                    className="rounded-full w-12 h-12"
                                  />
                                  <div>
                                    <h1 className="text-white w-full text-sm text-start">
                                      STATE PUBLIC SERVICE COMMISSION (PSC)
                                    </h1>
                                  </div>
                                </div>
                                <div className="text-white flex gap-3 ml-2">
                                  <h1 className="text-3xl font-bold">
                                    ₹ {e.offerPrice}
                                  </h1>
                                  <h1 className="line-through mt-2 text-purple">
                                    ₹{e.price}
                                  </h1>
                                </div>
                              </div>
                            </div>

                            <div className="flex font-bold text-lg mt-2 mb-2">
                              <h1>Course Information :</h1>
                            </div>

                            <ul
                              style={{ color: "#1C1A4A" }}
                              role="list"
                              class="mb-4 text-left h-64 grid grid-cols-1 lg:grid-cols-1 mt-2"
                            >
                              {e.exams.map((exam) => (
                                <React.Fragment key={exam._id || exam.examName}>
                                  <li class="flex items-center space-x-2 justify-between">
                                    <div className="flex gap-4 justify-center items-center">
                                      <img src={Correct} alt="" />
                                      <span class="text-base-content/80">
                                        {exam.examName}
                                      </span>
                                    </div>
                                    <div>
                                      <img src={Info} alt="" />
                                    </div>
                                  </li>
                                  <hr class="h-px bg-midGray border-1 dark:bg-black" />
                                </React.Fragment>
                              ))}
                            </ul>

                            <Link to={"/login"}>
                              <div className="w-40 m-auto flex py-2 justify-center items-center gap-4 rounded-full bg-bgBlue text-white  transition duration-300 mt-2 shadow-[4px_6px_#A695AE]">
                                <button>Buy Course</button>
                                <FaArrowRightLong />
                              </div>
                            </Link>
                          </div>
                        </>
                      );
                    }
                  })}
              </Slider>
            </div>
          </ScrollAnimation>

          <div className="mt-6">
            <Link to={"/courses"}>
              <div className="w-44 m-auto flex py-2.5 justify-center items-center gap-4 rounded-full bg-purple text-white shadow-[6px_6px_#4D2C5E] transition duration-300">
                <button>See All Courses</button>
                <FaArrowRightLong />
              </div>
            </Link>
          </div>
        </div>
        {/* </ScrollAnimation> */}

        {/* Contest Page */}

        <Contestpage />

 <WhyChooseUs/>

        {/* //upcomimg exame/ */}
        {/* <ScrollAnimation initiallyVisible={true}
          animateOnce={true} duration={3} animateIn="fadeIn" className="w-full">
          <div
            id="upcoming"
            className="bg-white w-full py-12 text-center font-oswald"
          >
            <div className=" flex items-center justify-center">
              <p
                style={{ backgroundColor: "#EFEEFE" }}
                className="border-2 border rounded-full py-2 px-6 font-bold text-bgBlue"
              >
                Trending
              </p>
            </div>
            <br />
            <h2 className="text-3xl font-bold text-gray-900 mb-2 animate-fade-in">
              Upcoming <span className="text-purple">Exams </span>{" "}
            </h2>
            <p className=" text-sm text-gray-900 mb-4 animate-fade-in lg:w-1/2 lg:m-auto ">
              Nullam eleifend metus ipsum, at ornare odio vehicula in.
              Pellentesque condimentum ntum vehicula.Nulla convallis enim eu
              velit commodo condimentum.
            </p>
            <br />
            <ScrollAnimation
              duration={3}
              animateIn="bounceInRight"
              animateOut="bounceOutLeft"
              initiallyVisible={true}
              animateOnce={true}
            >
              <div class="space-y-8 lg:w-3/4 w-full lg:grid lg:grid-cols-3 m-auto sm:gap-10 xl:gap-10 lg:space-y-0 p-4 lg:p-0">
                <div
                  style={{ backgroundColor: "#F1D9CC" }}
                  class="flex flex-col  max-w-md shadow-[6px_6px_#A695AE] xl:p-5 rounded-3xl h-52  transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 transition duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                >
                  <div className="  flex justify-between m-auto lg:m-0">
                    <img src={Upcoming} alt="" className="w-fit " />
                  </div>
                  <br />
                  <div class="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                    <span class=" text-xl font-semibold font-oswald text-black">
                      SSC MTS,SSC CHSL,SSC CGL
                    </span>
                    <span class=" text-sm font-bold">Apply Now</span>
                  </div>
                </div>

                <div
                  style={{ backgroundColor: "#EDEAFF" }}
                  class="flex flex-col  max-w-md shadow-[6px_6px_#A695AE] xl:p-5 rounded-3xl  h-52  transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 transition duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                >
                  <div className="  flex justify-between m-auto lg:m-0">
                    <img src={Upcoming} alt="" className="w-fit " />
                  </div>
                  <br />
                  <div class="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                    <span class=" text-xl font-semibold font-oswald text-black">
                      SSC MTS,SSC CHSL,SSC CGL
                    </span>
                    <span class=" text-sm font-bold">Apply Now</span>
                  </div>
                </div>

                <div
                  style={{ backgroundColor: "#F1FDFF" }}
                  class="flex flex-col  max-w-md shadow-[6px_6px_#A695AE] xl:p-5 rounded-2xl h-52  transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 transition duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                >
                  <div className="  flex justify-between m-auto lg:m-0">
                    <img src={Upcoming} alt="" className="w-fit " />
                  </div>
                  <br />
                  <div class="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                    <span class=" text-xl font-semibold font-oswald text-black">
                      SSC MTS,SSC CHSL,SSC CGL
                    </span>
                    <span class=" text-sm font-bold">Apply Now</span>
                  </div>
                </div>


                <div
                  style={{ backgroundColor: "#F1FDFF" }}
                  class="flex flex-col  max-w-md shadow-[6px_6px_#A695AE] xl:p-5 rounded-2xl h-52  transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 transition duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                >
                  <div className="  flex justify-between m-auto lg:m-0">
                    <img src={Upcoming} alt="" className="w-fit " />
                  </div>
                  <br />
                  <div class="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                    <span class=" text-xl font-semibold font-oswald text-black">
                      SSC MTS,SSC CHSL,SSC CGL
                    </span>
                    <span class=" text-sm font-bold">Apply Now</span>
                  </div>
                </div>

                <div
                  style={{ backgroundColor: "#FFF7E2" }}
                  class="flex flex-col  max-w-md shadow-[6px_6px_#A695AE] xl:p-5 rounded-2xl h-52  transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 transition duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                >
                  <div className="  flex justify-between m-auto lg:m-0">
                    <img src={Upcoming} alt="" className="w-fit " />
                  </div>
                  <br />
                  <div class="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                    <span class=" text-xl font-semibold font-oswald text-black">
                      SSC MTS,SSC CHSL,SSC CGL
                    </span>
                    <span class=" text-sm font-bold">Apply Now</span>
                  </div>
                </div>

                <div
                  style={{ backgroundColor: "#EDEAFF" }}
                  class="flex flex-col  max-w-md shadow-[6px_6px_#A695AE] xl:p-5 rounded-2xl h-52  transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 transition duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105"
                >
                  <div className="  flex justify-between m-auto lg:m-0">
                    <img src={Upcoming} alt="" className="w-fit " />
                  </div>
                  <br />
                  <div class="flex flex-col gap-4 m-auto lg:m-0 text-start my-5">
                    <span class=" text-xl font-semibold font-oswald text-black">
                      SSC MTS,SSC CHSL,SSC CGL
                    </span>
                    <span class=" text-sm font-bold">Apply Now</span>
                  </div>
                </div>

               
              </div>
            </ScrollAnimation>
            <br />
            
          </div>
        </ScrollAnimation> */}
        <UpcomingExam />

        {/* About us  */}

        <ScrollAnimation
          duration={3}
          animateIn="fadeIn"
          initiallyVisible={true}
          animateOnce={true}
          className="w-full"
        >
          <div
            id="about-us"
            className="w-full m-auto flex flex-col justify-center items-center"
          >
            <div className=" flex items-center justify-center lg:justify-start   ">
              <p
                style={{ backgroundColor: "#EFEEFE" }}
                className="border-2 border rounded-full py-2 px-6 font-bold text-bgBlue"
              >
                Get More About us
              </p>
            </div>
            <div className="lg:w-4/5  flex flex-col lg:flex-row items-center m-auto font-poppins text-center ">
              <div
                className={`lg:w-1/2 ${
                  slideIn ? "animate-slide-in-right" : ""
                } `}
              >
                <img
                  src={AboutImamge}
                  alt="About"
                  className=" lg:max-w-2xl w-96  m-auto lg:m-0"
                />
              </div>
              <div className={`w-full lg:w-1/2 lg:text-start  p-2 lg:p-0`}>
                <br />

                <h1 className="text-2xl lg:text-3xl font-bold font-poppins text-bgBlue mb-4 animate-slide-in-left">
                  Empowering Students to reach their{" "}
                  <span className="text-purple">potential</span> Goal For Next
                  Level Challenge.{" "}
                </h1>

                <p className="text-sm  text-bgBlue mb-6 animate-slide-in-left">
                  Empowering students to reach their potential involves
                  providing them with the tools, resources, and support needed
                  to overcome challenges and achieve their goals. By fostering a
                  growth mindset, offering personalized learning experiences,
                  and encouraging perseverance, students can be prepared to
                  tackle the next level of their educational and professional
                  journeys. This holistic approach not only boosts their
                  confidence but also equips them with the skills necessary for
                  lifelong success.{" "}
                </p>
                <div className="mt-6">
                  <Link to={"/login"}>
                    <div className="w-44 flex m-auto lg:m-0 py-2.5 justify-center items-center gap-4 rounded-full bg-purple text-white shadow-[6px_6px_#4D2C5E] transition duration-300">
                      <button>Start Free Trial</button>
                      <FaArrowRightLong />
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            <div className="w-full flex justify-center items-center bg-white  lg:p-0 mt-4 ">
              <div className="bg-bgBlue lg:p-8 p-4 lg:rounded-lg flex lg:flex-row flex-col gap-6 lg:gap-0 justify-between items-center lg:w-4/5 w-full ">
                <div className="text-center">
                  <p className="lg:text-3xl font-bold text-white">
                    <CountUp end={4500} duration={2} />
                    K+
                  </p>
                  <p className="text-sm text-gray-300">Number of Users</p>
                </div>
                {/* <div className="border-l border-gray-200 h-16 block hidden"></div> */}
                <div className="text-center ">
                  <p className="lg:text-3xl font-bold text-white">
                    <CountUp end={4.6} duration={2} decimals={1} />
                  </p>
                  <p className="text-sm text-gray-300">Star Rating</p>
                </div>
                {/* <div className="border-l border-gray-200 h-16 "></div> */}
                <div className="text-center">
                  <p className="lg:text-3xl font-bold text-white">
                    <CountUp end={328} duration={2} />+
                  </p>
                  <p className="text-sm text-gray-300">Number Of Tests Taken</p>
                </div>
                {/* <div className="border-l border-gray-200 h-16 "></div> */}
                <div className="text-center">
                  <p className="lg:text-3xl font-bold text-white">
                    <CountUp end={80} duration={2} />
                    K+
                  </p>
                  <p className="text-sm text-gray-300">Questions Attempted</p>
                </div>
                {/* <div className="border-l border-gray-200 h-16 "></div> */}
                <div className="relative w-48 lg:h-32 h-24 hidden ">
                  <img
                    src={FactImage}
                    alt="Statistics"
                    className="absolute top-0 left-0 w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </ScrollAnimation>

        {/* <WhyChooseUs /> */}
      

        {/* FAQS Section */}

        <FaqsPage />

        {/* Testimonials Section */}

        <ScrollAnimation
          duration={4}
          animateIn="fadeIn"
          initiallyVisible={true}
          animateOnce={true}
          className="w-full"
        >
          <div
            id="Testimonials"
            className="bg-white w-full  text-center font-oswald"
          >
            <div className=" flex items-center justify-center">
              <p
                style={{ backgroundColor: "#EFEEFE" }}
                className="border-2 border rounded-full py-2 px-6 font-bold text-bgBlue"
              >
                Our Testimonials
              </p>
            </div>
            <br />
            <h2 className="text-3xl font-bold text-gray-900 mb-2 animate-fade-in">
              What Students Think and Say About{" "}
              <span className="text-purple">Learn2Earn24x7</span>{" "}
            </h2>
            <p className=" text-sm text-gray-900 mb-4 animate-fade-in lg:w-1/2 lg:m-auto ">
              “I not only gained new skills but also started earning through what I learned!”
            </p>
            <br />
            <div class="py-2 px-6  lg:px-20">
              <Slider {...settings} className="slider-container">
                <div
                  style={{ backgroundColor: "#F6F5FE" }}
                  class="  w-full   xl:p-5 p-6 rounded-xl "
                >
                  {/* <div className="flex justify-end">
                <img src={Star} alt="" />
              </div> */}
                  <div className="flex justify-between p-4 w-full">
                    <div className="flex  gap-6 justify-center items-center">
                      <div className="  flex justify-between   ">
                        <img src={ReferShare} alt="" className="w-12 h-12 " />
                      </div>

                      <div class="flex flex-col gap-2 m-auto lg:m-0 text-start  ">
                        <img src={Ratingstars} alt="" />
                        <span class=" text-xl font-semibold font-oswald text-black ">
                          Meenal Jain
                        </span>
                      </div>
                    </div>
                    <div>
                      <img src={QuamaImage} alt="" className="w-12 " />
                    </div>
                  </div>

                  <span class=" text-sm font-bold text-start flex mt-2 xl:px-8">
                    "A good Platform for Beginers and Learns to get Knowledge".
                  </span>
                </div>
                <div
                  style={{ backgroundColor: "#F6F5FE" }}
                  class="   max-w-md  xl:p-5 p-6 rounded-xl h-48  "
                >
                  {/* <div className="flex justify-end">
                <img src={Star} alt="" />
              </div> */}
                  <div className="flex justify-between p-4">
                    <div className="flex  gap-6 justify-center items-center">
                      <div className="  flex justify-between   ">
                        <img src={ReferShare} alt="" className="w-12 h-12 " />
                      </div>

                      <div class="flex flex-col gap-2 m-auto lg:m-0 text-start  ">
                        <img src={Ratingstars} alt="" />
                        <span class=" text-xl font-semibold font-oswald text-black ">
                          Lokesh Kumar
                        </span>
                      </div>
                    </div>
                    <div>
                      <img src={QuamaImage} alt="" className="w-12 " />
                    </div>
                  </div>

                  <span class=" text-sm font-bold text-start flex mt-2 xl:px-8">
                    "Amazing Paltform for Learning and Earnig for Students".
                  </span>
                </div>
                <div
                  style={{ backgroundColor: "#F6F5FE" }}
                  class="   max-w-md  xl:p-5 p-6 rounded-xl h-48  "
                >
                  {/* <div className="flex justify-end">
                <img src={Star} alt="" />
              </div> */}
                  <div className="flex justify-between p-4">
                    <div className="flex  gap-6 justify-center items-center">
                      <div className="  flex justify-between   ">
                        <img src={ReferShare} alt="" className="w-12 h-12 " />
                      </div>

                      <div class="flex flex-col gap-2 m-auto lg:m-0 text-start  ">
                        <img src={Ratingstars} alt="" />
                        <span class=" text-xl font-semibold font-oswald text-black ">
                          Rishikesh Suryawanshi
                        </span>
                      </div>
                    </div>
                    <div>
                      <img src={QuamaImage} alt="" className="w-12 " />
                    </div>
                  </div>

                  <span class=" text-sm font-bold text-start flex mt-2 xl:px-8">
                    "Easiest Way to Explore new things and Kwonledge".
                  </span>
                </div>
                <div
                  style={{ backgroundColor: "#F6F5FE" }}
                  class="   max-w-md  xl:p-5 p-6 rounded-xl h-48  "
                >
                  {/* <div className="flex justify-end">
                <img src={Star} alt="" />
              </div> */}
                  <div className="flex justify-between p-4">
                    <div className="flex  gap-6 justify-center items-center">
                      <div className="  flex justify-between   ">
                        <img src={ReferShare} alt="" className="w-12 h-12 " />
                      </div>

                      <div class="flex flex-col gap-2 m-auto lg:m-0 text-start  ">
                        <img src={Ratingstars} alt="" />
                        <span class=" text-xl font-semibold font-oswald text-black ">
                          Neha Shah
                        </span>
                      </div>
                    </div>
                    <div>
                      <img src={QuamaImage} alt="" className="w-12 " />
                    </div>
                  </div>

                  <span class=" text-sm font-bold text-start flex mt-2 xl:px-8">
                    "Best Thing for Learns to get Knowledge".
                  </span>
                </div>
                <div
                  style={{ backgroundColor: "#F6F5FE" }}
                  class="   max-w-md  xl:p-5 p-6 rounded-xl h-48  "
                >
                  {/* <div className="flex justify-end">
                <img src={Star} alt="" />
              </div> */}
                  <div className="flex justify-between p-4">
                    <div className="flex  gap-6 justify-center items-center">
                      <div className="  flex justify-between   ">
                        <img src={ReferShare} alt="" className="w-12 h-12 " />
                      </div>

                      <div class="flex flex-col gap-2 m-auto lg:m-0 text-start  ">
                        <img src={Ratingstars} alt="" />
                        <span class=" text-xl font-semibold font-oswald text-black ">
                          Nilesh Tiwari
                        </span>
                      </div>
                    </div>
                    <div>
                      <img src={QuamaImage} alt="" className="w-12 " />
                    </div>
                  </div>

                  <span class=" text-sm font-bold text-start flex mt-2 xl:px-8">
                    "Little progress each day adds up to big results".
                  </span>
                </div>
                <div
                  style={{ backgroundColor: "#F6F5FE" }}
                  class="   max-w-md  xl:p-5 p-6 rounded-xl h-48  "
                >
                  {/* <div className="flex justify-end">
                <img src={Star} alt="" />
              </div> */}
                  <div className="flex justify-between p-4">
                    <div className="flex  gap-6 justify-center items-center">
                      <div className="  flex justify-between   ">
                        <img src={ReferShare} alt="" className="w-12 h-12 " />
                      </div>

                      <div class="flex flex-col gap-2 m-auto lg:m-0 text-start  ">
                        <img src={Ratingstars} alt="" />
                        <span class=" text-xl font-semibold font-oswald text-black ">
                          Mehul Sharma
                        </span>
                      </div>
                    </div>
                    <div>
                      <img src={QuamaImage} alt="" className="w-12 " />
                    </div>
                  </div>

                  <span class=" text-sm font-bold text-start flex mt-2 xl:px-8">
                    "Grow your skills, and your income will grow with them".
                  </span>
                </div>
              </Slider>
            </div>
          </div>
        </ScrollAnimation>

        {/* Contact Section */}
        <ScrollAnimation
          duration={4}
          animateIn="fadeIn"
          initiallyVisible={true}
          animateOnce={true}
          className="w-full"
        >
          <Contactus />
        </ScrollAnimation>

        {/* Footer Section */}

        {/* <Footer /> */}
      </div>
    </div>
  );
}

export default Dashboard;
